
export const CREATE_SCENARIO = 'CREATE_SCENARIO';
export const CREATE_SCENARIO_SUCCESS = 'CREATE_SCENARIO_SUCCESS';
export const CREATE_SCENARIO_FAIL = 'CREATE_SCENARIO_FAIL';

export const UPDATE_SCENARIO = 'UPDATE_SCENARIO';
export const UPDATE_SCENARIO_SUCCESS = 'UPDATE_SCENARIO_SUCCESS';
export const UPDATE_SCENARIO_FAIL = 'UPDATE_SCENARIO_FAIL';

export const DELETE_SCENARIO = 'DELETE_SCENARIO';
export const DELETE_SCENARIO_SUCCESS = 'DELETE_SCENARIO_SUCCESS';
export const DELETE_SCENARIO_FAIL = 'DELETE_SCENARIO_FAIL';

export const LOAD_SCENARIOS = 'LOAD_SCENARIOS';
export const LOAD_SCENARIOS_SUCCESS = 'LOAD_SCENARIOS_SUCCESS';
export const LOAD_SCENARIOS_FAIL = 'LOAD_SCENARIOS_FAIL';

const initialState = {
  loading: false,

  scenariosMap: {},
  error: undefined
};



const ScenariosReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case CREATE_SCENARIO:
    case UPDATE_SCENARIO:
    case DELETE_SCENARIO:
    case LOAD_SCENARIOS:
      return {
        ...state,
        loading: true,
        error: undefined
      };

    case CREATE_SCENARIO_FAIL:
    case UPDATE_SCENARIO_FAIL:
    case DELETE_SCENARIO_FAIL:
    case LOAD_SCENARIOS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case CREATE_SCENARIO_SUCCESS:
    case UPDATE_SCENARIO_SUCCESS:
      return {
        ...state,
        loading: false,
        scenariosMap: {
          ...state.scenariosMap,
          [action.scenario.id]: action.scenario
        }
      };

    case DELETE_SCENARIO_SUCCESS:
      return {
        ...state,
        loading: false,
        scenariosMap: {
          ...state.scenariosMap,
          [action.id]: undefined
        }
      };

    case LOAD_SCENARIOS_SUCCESS:
      return {
        ...state,
        loading: false,
        scenariosMap: {
          ...state.scenariosMap,
          ...action.scenarios.reduce((map, form) => ({ ...map, [form.id]: form }), {})
        }
      };

    default:
      return state;
  }
};

export default ScenariosReducer;
